import { showApiErrorSnackbar, showApiSuccessSnackbar } from '@/shared/helpers/thunk';
import { baseApi } from '@/admin/baseApi';
import { t } from '@/core/localization';
export const customerApi = baseApi
    .enhanceEndpoints({
    addTagTypes: [
        'Customers',
        'DeliveryAddresses',
        'Emails',
        'NotifySchedule',
        'ShippingSettings',
        'PriceListMarkup',
        'OrderImportRules',
    ],
})
    .injectEndpoints({
    endpoints: (builder) => ({
        // Customers
        getCustomers: builder.query({
            query: ({ limit = 100, offset, search }) => ({
                url: 'Customer',
                params: { limit, offset, search },
                method: 'GET',
            }),
            transformResponse: (response) => response.map((customer) => ({ ...customer, createDate: new Date(customer.createDate) })),
        }),
        getCustomer: builder.query({
            query: (customerId) => ({
                method: 'GET',
                url: `Customer/${customerId}`,
            }),
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.customer.request.failed'), error }));
                }
            },
            transformResponse: (response) => ({
                ...response,
                createDate: new Date(response.createDate),
                changeDate: new Date(response.changeDate),
                birthday: response.birthday ? new Date(response.birthday) : null,
                contractDate: new Date(response.contractDate),
                // TODO: !!!important to delete when `paymentDelayDayType` is added to backend model!!!!!!!!!!!!!!
                paymentDelayDayType: response.paymentDelayDayType ?? 1,
                useSeparateShippingForTrackables: response.useSeparateShippingForTrackables ?? false,
            }),
            providesTags: (result, error, id) => [{ type: 'Customers', id }],
        }),
        addCustomer: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: `customer`,
                body,
            }),
        }),
        // TODO: to delete only after all instances will have been merged to latest versions, and backed and db fixed accordingly
        // THIS IS TEMPORARY ENDPOINT
        // DELETE /api/customer/{customerId}/driver
        deleteDriverTemporary: builder.mutation({
            query: (customerId) => ({
                method: 'DELETE',
                url: `customer/${customerId}/driver`,
            }),
            // useInfinityScroll refresh is used for update customer row.
            // invalidatesTags: (result, error, { customerId }) => [{ type: 'Customers', id: customerId }],
        }),
        updateCustomer: builder.mutation({
            query: ({ customerId, ...body }) => ({
                method: 'PUT',
                url: `customer/${customerId}`,
                body,
            }),
            // useInfinityScroll refresh is used for update customer row.
            // invalidatesTags: (result, error, { customerId }) => [{ type: 'Customers', id: customerId }],
        }),
        setCustomerActive: builder.mutation({
            query: ({ customerId, isActive }) => ({
                method: 'PUT',
                url: `Customer/${customerId}/active/${isActive}`,
            }),
            invalidatesTags: (result, error, { customerId }) => [{ type: 'Customers', customerId }],
        }),
        // Payments
        // TODO: to delete legacy endpoint later
        getTransactions_Legacy: builder.query({
            query: ({ customerId, limit = 100, offset }) => ({
                method: 'GET',
                url: 'userfullinfo/transactions',
                params: { userid: customerId, page: offset / limit, rowscount: limit },
            }),
            transformResponse: (response) => ({
                ...response,
                payments: response.payments.map((tran) => ({ ...tran, date: new Date(tran.date) })),
            }),
        }),
        // TODO: to delete legacy endpoint later
        getPaymentBalance_Legacy: builder.query({
            query: ({ customerId, limit = 100, offset }) => ({
                method: 'GET',
                url: `customer/payment-balance/${customerId}`,
                params: {
                    page: offset / limit,
                    pageSize: limit,
                },
            }),
        }),
        getCustomerPaymentBalance: builder.infiniteQuery({
            infiniteQueryOptions: {
                initialPageParam: 1,
                // getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams, queryArg) => lastPageParam + 1,
                getNextPageParam: (lastPage) => (lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined),
                // getNextPageParam: (lastPage) => {
                // 	// TODO: to delete
                // 	console.log('lastPage.page', lastPage.page);
                // 	console.log('lastPage.pageSize', lastPage.pageSize);
                // 	console.log('lastPage.totalCount', lastPage.totalCount);
                // 	// const hasMore = lastPage.page * lastPage.pageSize < lastPage.totalCount;
                // 	// return hasMore ? lastPage.page + 1 : undefined;
                // 	const hasMore = lastPage.page < lastPage.totalPages
                // 	return hasMore ? lastPage.page + 1 : undefined;
                // },
            },
            query: ({ queryArg: { customerId, pageSize = 20 }, pageParam }) => ({
                method: 'GET',
                url: `customer/payment-balance/${customerId}`,
                params: {
                    page: pageParam,
                    pageSize,
                },
            }),
        }),
        rechargeBalance: builder.mutation({
            query: ({ customerId, ...body }) => ({
                method: 'POST',
                url: `userfullinfo/addpayment`,
                params: { userid: customerId },
                body: body,
            }),
            //invalidatesTags: (result, error, { customerId }) => [{ type: 'Customers', customerId }],
        }),
        // Delivery addresses
        // getDeliveryAddresses: builder.query<DeliveryAddress[], { customerId: number }>({
        // 	query: ({ customerId }) => ({
        // 		method: 'GET',
        // 		url: `Customer/${customerId}/delivery-addresses`,
        // 	}),
        // 	providesTags: (result, error, arg) => [{ type: 'DeliveryAddresses', id: arg.customerId }],
        // 	// TODO: to delete this transformResponse when address is ok.
        // 	transformResponse: (response: (DeliveryAddress & { city: string })[]) => {
        // 		return response.map((r) => {
        // 			return { ...r, deliveryAddress: r.city } as DeliveryAddress;
        // 		});
        // 	},
        // }),
        // editDeliveryAddress: builder.mutation<DeliveryAddress, { customerId: number; deliveryAddress: Partial<DeliveryAddress> }>({
        // 	query: ({ customerId, deliveryAddress }) => ({
        // 		method: deliveryAddress.deliveryAddressId ? 'PUT' : 'POST',
        // 		url: `Customer/${customerId}/delivery-addresses${deliveryAddress.deliveryAddressId ? '/' + deliveryAddress.deliveryAddressId : ''}`,
        // 		// TODO: to return this after address becomes one-line.
        // 		//body,
        // 		// JUST A MOCK to be deleted
        // 		//body: { ...body, city: body.deliveryAddress, street: 'STREET', house: 'HOUSE', office: 'OFFICE', structure: 'STRUCTURE', building: 'BUILDING' },
        // 		body: {
        // 			...deliveryAddress,
        // 			city: deliveryAddress.deliveryAddress,
        // 			street: 'STREET',
        // 			house: 'HOUSE',
        // 			office: 'OFFICE',
        // 			structure: 'STRUCTURE',
        // 			building: 'BUILDING',
        // 		},
        // 	}),
        // 	onQueryStarted: async ({ deliveryAddress }, { dispatch, queryFulfilled }) => {
        // 		try {
        // 			await queryFulfilled;
        // 		} catch (error) {
        // 			dispatch(
        // 				showApiErrorSnackbar({
        // 					header: deliveryAddress.deliveryAddressId
        // 						? t('edit.customer.delivery.address.request.failed')
        // 						: t('add.customer.delivery.address.request.failed'),
        // 					error,
        // 				})
        // 			);
        // 		}
        // 	},
        // 	invalidatesTags: (result, error, arg) => [{ type: 'DeliveryAddresses', id: arg.customerId }],
        // }),
        // deleteDeliveryAddress: builder.mutation<void, { customerId: number; deliveryAddressId: number }>({
        // 	query: ({ customerId, deliveryAddressId }) => ({
        // 		method: 'DELETE',
        // 		url: `Customer/${customerId}/delivery-addresses/${deliveryAddressId}`,
        // 	}),
        // 	invalidatesTags: (result, error, arg) => (error ? [] : [{ type: 'DeliveryAddresses', id: arg.customerId }]),
        // }),
        // Shipping
        // getShippingSettings: builder.query<ShippingSettings, number>({
        // 	query: (customerId) => ({
        // 		method: 'GET',
        // 		url: `Customer/${customerId}/pickingSettings`,
        // 	}),
        // 	providesTags: ['ShippingSettings'],
        // }),
        // updateShippingSettings: builder.mutation<void, { shippingSettings: ShippingSettings; customerId: number }>({
        // 	query: ({ shippingSettings, customerId }) => ({
        // 		method: 'PUT',
        // 		url: `Customer/${customerId}/pickingSettings`,
        // 		body: shippingSettings,
        // 	}),
        // 	invalidatesTags: ['ShippingSettings'],
        // }),
        // Emails
        getEmails: builder.query({
            query: (customerId) => ({
                method: 'GET',
                url: `Customer/${customerId}/emails`,
            }),
            providesTags: ['Emails'],
        }),
        editEmail: builder.mutation({
            query: ({ customerId, ...email }) => email.emailId
                ? {
                    method: 'PUT',
                    url: `Customer/${customerId}/emails/${email.emailId}`,
                    body: email,
                }
                : {
                    method: 'POST',
                    url: `Customer/${customerId}/emails`,
                    body: email,
                },
            invalidatesTags: ['Emails'],
        }),
        deleteEmail: builder.mutation({
            query: ({ customerId, emailId }) => ({
                method: 'DELETE',
                url: `Customer/${customerId}/emails/${emailId}`,
            }),
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                    dispatch(showApiSuccessSnackbar(t('customer.email.has.been.successfully.deleted')));
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('delete.customer.email.request.failed'), error }));
                }
            },
            invalidatesTags: ['Emails'],
        }),
        // Schedule
        getNotifySchedule: builder.query({
            query: ({ customerId }) => ({
                method: 'GET',
                url: `Customer/${customerId}/notifySchedule`,
            }),
            transformResponse: (result) => result.map((item) => (item.length > 5 ? item.slice(0, 5) : item)),
            providesTags: ['NotifySchedule'],
        }),
        editNotifySchedule: builder.mutation({
            query: ({ customerId, scheduleItems }) => ({
                method: 'POST',
                url: `Customer/${customerId}/notifySchedule`,
                body: scheduleItems,
            }),
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                    dispatch(showApiSuccessSnackbar(t('notification.schedule.has.been.successfully.updated')));
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('update.customer.notify.schedule.request.failed'), error }));
                }
            },
            invalidatesTags: ['NotifySchedule'],
        }),
        // getPriceListMarkup: builder.query<IPriceListMarkup[], { customerId: number | string; search: string }>({
        getPriceListMarkup: builder.query({
            query: ({ customerId }) => ({
                method: 'GET',
                //url: `Customer/${customerId}/priceListMarkup`,
                url: `markup/pricelist`,
                params: { userid: customerId },
            }),
            providesTags: ['PriceListMarkup'],
        }),
        setPriceListMarkup: builder.mutation({
            query: ({ customerId, priceListId, markup }) => ({
                method: 'POST',
                url: `markup/pricelist`,
                params: { userid: customerId, pricelistid: priceListId },
                body: markup || {},
            }),
            invalidatesTags: (result, error, { priceListId }) => [{ type: 'PriceListMarkup', priceListId }],
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                    dispatch(showApiSuccessSnackbar(t('personal.markup.on.the.price.list.has.been.successfully.updated')));
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('personal.markup.on.the.price.list.update.request.failed'), error }));
                }
            },
        }),
        setConnectedToWebApp: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: `Customer/ConnectedToWebAppState/${body.priceListId}`,
                body,
            }),
            //invalidatesTags: (result, error, { priceListId }) => [{ type: 'PriceLists', priceListId }],
        }),
        setConnectedToCustomer: builder.mutation({
            query: ({ customerId, priceListId, active }) => ({
                method: 'POST',
                url: `markup/pricelistavailability`,
                params: { userId: customerId, pricelistId: priceListId },
                body: active,
            }),
            invalidatesTags: (result, error, { priceListId }) => [{ type: 'PriceListMarkup', priceListId }],
        }),
        // Order import rules
        // LEGACY backend
        getOrderImportRules: builder.query({
            query: ({ customerId }) => ({
                method: 'GET',
                //url: `Customer/${customerId}/getOrderImportRules`,
                url: `externalOrder/list`,
                params: { userId: customerId },
            }),
            // TODO: remove only when new backend endpoint is done.
            transformResponse: (response) => response
                .map((item) => ({ ...item, createDate: new Date(item.createDate) }))
                .sort((a, b) => b.createDate.getTime() - a.createDate.getTime()),
            providesTags: ['OrderImportRules'],
            // TODO: try use it with new backend
            // providesTags: (result) => providesList(result, 'OrderImportRules', 'externalOrderSettingsId'),
        }),
        getOrderImportRule: builder.query({
            query: ({ customerId, ruleId }) => `customer/${customerId}/eva/${ruleId}`,
            providesTags: ['OrderImportRules'],
        }),
        createOrderImportRule: builder.mutation({
            query: (rule) => ({
                method: 'POST',
                url: `customer/${rule.customerId}/eva`,
                body: rule,
            }),
            invalidatesTags: ['OrderImportRules'],
        }),
        updateOrderImportRule: builder.mutation({
            query: (rule) => ({
                method: 'PUT',
                url: `customer/${rule.customerId}/eva/${rule.externalOrderSettingsId}`,
                body: rule,
            }),
            invalidatesTags: ['OrderImportRules'],
            // TODO: check if it is working
            // invalidatesTags: (result, error, { customerId: id }) => [{ type: 'OrderImportRules', id }],
        }),
        // LEGACY backend
        deleteOrderImportRule: builder.mutation({
            query: ({ ruleId }) => ({
                method: 'DELETE',
                url: `externalOrder`,
                params: { settingId: ruleId },
            }),
            invalidatesTags: (result, error, { ruleId }) => [{ type: 'OrderImportRules', ruleId }],
        }),
        // LEGACY backend
        // setOrderImportRuleActive: builder.mutation<void, { customerId: number; settingsId: number; isActive: boolean }>({
        setOrderImportRuleActive: builder.mutation({
            // query: (body) => ({
            query: ({ settingId, isActive }) => ({
                method: 'POST',
                url: `externalOrder/availability`,
                params: { settingId },
                // body,
                body: isActive,
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
            // invalidatesTags: (result, error, { settingsId }) => [{ type: 'OrderImportRules', settingsId }],
            invalidatesTags: (result, error, { settingId }) => [{ type: 'OrderImportRules', settingId }],
        }),
        // LEGACY backend
        getExportPriceLists: builder.query({
            query: () => ({
                method: 'GET',
                url: 'exportpricelist',
            }),
        }),
    }),
});
export const { useGetCustomersQuery, useGetCustomerQuery, useLazyGetCustomerQuery, useUpdateCustomerMutation, useGetTransactions_LegacyQuery, useGetPaymentBalance_LegacyQuery, useGetCustomerPaymentBalanceInfiniteQuery, useRechargeBalanceMutation, useSetCustomerActiveMutation, useAddCustomerMutation, 
// useGetDeliveryAddressesQuery,
// useEditDeliveryAddressMutation,
// useGetShippingSettingsQuery,
// useUpdateShippingSettingsMutation,
useGetEmailsQuery, useEditEmailMutation, useDeleteEmailMutation, useGetNotifyScheduleQuery, useEditNotifyScheduleMutation, useGetPriceListMarkupQuery, useSetPriceListMarkupMutation, useSetConnectedToWebAppMutation, useSetConnectedToCustomerMutation, useGetOrderImportRulesQuery, useGetOrderImportRuleQuery, useGetExportPriceListsQuery, } = customerApi;
